import React from "react";
import {
  InfoMessageContainer,
  InfoMessageTypography,
} from "./InfoMessage.styles";
import { VariantStyles, SizeStyles } from "./InfoMessage.variants";
import { SxProps, Theme, useTheme } from "@mui/material/styles";
import { Icon, IconName } from "../../icons";

export interface CustomInfoMessageProps {
  variant?: "info" | "error";
  message: string | React.ReactElement;
  hasBackground?: boolean;
  hasIcon?: boolean;
  size?: "sm" | "md" | "lg";
  weight?: 1 | 2 | 3;
  sx?: SxProps<Theme>;
}

export const InfoMessage = ({
  variant = "info",
  message,
  size = "md",
  hasBackground = false,
  hasIcon = true,
  weight = 1,
  sx,
  ...rest
}: CustomInfoMessageProps) => {
  const theme = useTheme();

  const sizeStylesFn = SizeStyles(theme);
  const variantStylesFn = VariantStyles(theme, hasBackground, hasIcon);

  let icon: IconName;
  switch (variant) {
    case "info":
      icon = "InformationCircle";
      break;
    case "error":
      icon = "Exclamation";
      break;
    default:
      icon = "InformationCircle";
  }

  return (
    <InfoMessageContainer data-cy={`info-message-${variant}`}
      sx={{
        ...variantStylesFn[variant],
        ...sx
      }}
      {...rest}
    >
      {hasIcon && <Icon icon={icon} weight={weight} size={size} />}
      <InfoMessageTypography sx={{ ...sizeStylesFn[size] }}>{message}</InfoMessageTypography>
    </InfoMessageContainer>
  );
};

export interface InfoMessageProps
  extends React.ComponentProps<typeof InfoMessage> {
  as?: React.ElementType;
}

InfoMessage.displayName = "InfoMessage";
